import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { CustomerSelectionService } from '../services/customer-selection';

@Injectable({ providedIn: 'root' })
export class CustomerSelectedGuard implements CanActivate {
  constructor(
    private customerService: CustomerSelectionService,
    private router: Router
  ) { }

  canActivate(): boolean | UrlTree {
    const customer = this.customerService.getSelected();
    return customer
      ? true
      : this.router.createUrlTree(['/']); // Redirect to home or selection page
  }
}
